import { TotalViewsTimescale } from '../../../types'

export const DEFAULT_TIMESCALE: TotalViewsTimescale = 'LAST_7_DAYS'

export const TIMESCALE_LABELS: Record<TotalViewsTimescale, string> = {
  LAST_7_DAYS: 'Last 7 days',
  LAST_14_DAYS: 'Last 14 days',
  LAST_30_DAYS: 'Last 30 days'
}
